import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';

const mapState = (
  { results }: StateType,
  { type }: { type: keyof StateType['results']['counts'] },
) => {
  const count = results.counts[type] || 0;
  return {
    showCount: results.counts.hasOwnProperty(type),
    countOverride: count > Math.floor(count),
    count: Math.floor(count),
  };
};

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
